














import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { UserProfile } from "@api/models/UserProfile";
import UsersList from "../../common/users-list/UsersList.vue";
import { getElementOffsetWidth } from "@service/helpers/domHelper";
import { getHowMuchWillFit } from "@service/helpers/elementSizeHelper";

@Component({
    components: { UsersList }
})

export default class FittedUsersList extends Vue {
    @Prop({ required: true }) speakers: UserProfile[];
    @Prop({ default: false }) useSmallIcon: boolean;
    @Prop({ default: 42 }) fullProfileMargin: number;
    @Prop({ default: 240 }) fullProfileWidth: number;
    @Prop({ default: 4 }) fullCount: number;

    speakersMoreAmount = 0;
    speakersList: UserProfile[] = [];
    containerWidth: number | null = null;
    hideInfo = false;

    mounted() {
        this.setSpeakersList();
    }

    updateList() {
        this.setSpeakersList();
        this.$emit('update')
    }

    @Watch('speakers')
    setSpeakersList() {

        const length = this.speakers?.length;
        const speakersListElement = ((this.$refs['speakersList'] as Vue)?.$el as HTMLElement | undefined);

        if(length && speakersListElement) {

            this.hideInfo = this.speakers.length > this.fullCount ? true : !this.fullProfilesWillFit(this.speakers);

            let containerWidth = getElementOffsetWidth(speakersListElement);
            if(containerWidth) {
                this.containerWidth = containerWidth;
            }
            else {
                containerWidth = this.containerWidth || 0
            }

            let howMuchWillFit = getHowMuchWillFit((containerWidth - this.userIconSize), this.userIconSize + 11);

            //Если все иконки не помещаются
            if(this.hideInfo && howMuchWillFit < length) {

                if(howMuchWillFit < 0) {
                    howMuchWillFit = 0
                    this.speakersMoreAmount = 0
                }
                else {
                    this.speakersMoreAmount = length - howMuchWillFit;
                }

                this.speakersList = this.speakers.slice(0, howMuchWillFit);
            }
            else {
                this.speakersList = this.speakers;
                this.speakersMoreAmount = 0;
            }
        }
        else if(length === 0) {
            this.speakersList = this.speakers;
        }
    }

    /**
     * Поместятся ли блоки пользователей с полной инфомацией в имеющейся контейнер
     */
    fullProfilesWillFit(list: UserProfile[]): boolean {

        let length = list.length;

        if(length) {

            const speakersListElement = ((this.$refs['speakersList'] as Vue)?.$el as HTMLElement);
            const howMuchWillFit = this.getFullProfilesFit(length, speakersListElement);

            return howMuchWillFit >= length;

        }
        else {
            return true;
        }
    }

    getFullProfilesFit(length: number, speakersListElement?: HTMLElement) {

        //примерная ширина блока одного профиля
        const userBlockContentWidth = this.fullProfileWidth;

        //средний примерный размер отступа

        const userBlockMargin = length > 1 ? (this.fullProfileMargin * length) / (length - 1) : 0;

        const containerWidth = getElementOffsetWidth(speakersListElement);
        const contentWidth = userBlockContentWidth + userBlockMargin;

        return getHowMuchWillFit((containerWidth), contentWidth);
    }

    get userIconSize() {
        return this.useSmallIcon ? 32 : this.hideInfo ? 38 : 44;
    }
}
